/* eslint-disable max-len */
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Select from 'react-select';
import { CustomStyle } from '../../../../../components/CustomSelectStyle';
import Loader from '../../../../../components/Loader';

import { Form, ButtonContainer } from '../../../../../components/Form';

import FormGroup from '../../../../../components/FormGroup';

import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import NoData from '../../../../../components/NoData';
import useVehicleForm from './useVehicleForm';
import OpacityAnimation from '../../../../../components/OpacityAnimation';

interface VehicleFormInterface {
  edit?: boolean
}

export default function VehicleForm({ edit = false }: VehicleFormInterface) {
  const {
    model,
    transportType,
    vehicleCode,
    brand,
    capacity,
    consumption,
    workplace,
    affreightmentLines,
    setTransportType,
    isLoading,
    isSelectLoading,
    isLinesSelectLoading,
    isLinesSelectDisabled,
    apiVehicleFetched,
    apiWorkplaceFetched,
    doesListWorkplacesExists,
    getErrorMessageByFieldName,
    animatedComponents,
    isFormValid,
    workplacesOptions,
    linesOptions,
    transportKindOptions,
    handleGetVehicleTryAgain,
    handleGetWorkplacesTryAgain,
    handleModelChange,
    handleVehicleCodeChange,
    handleBrandChange,
    handleCapacityChange,
    handleConsumptionChange,
    handleLocTrabChange,
    handleLinesChange,
    createLine,
    editLine,
  } = useVehicleForm({ edit });

  return (
    <>
      <Loader isLoading={isLoading} />
      {(apiVehicleFetched && apiWorkplaceFetched && doesListWorkplacesExists && !isLoading) && (
        <OpacityAnimation delay={0.1}>
          <Form noValidate autoComplete="new-password">
            <Container>

              <Row xs={1} md={1} lg={2}>
                <Col>
                  <FormGroup error={getErrorMessageByFieldName('vehicleCode')}>
                    <label htmlFor="codVeiculo">Código do veículo *</label>
                    <Input
                      placeholder="Código do veículo *"
                      value={vehicleCode}
                      onChange={handleVehicleCodeChange}
                      maxLength={20}
                      disabled={edit}
                      error={getErrorMessageByFieldName('vehicleCode')}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <label htmlFor="tipoVeiculo">Tipo *</label>
                    <Select
                      value={transportType}
                      options={transportKindOptions}
                      onChange={(opt) => setTransportType(opt!)}
                      placeholder="Selecione um tipo de veículo"
                      styles={CustomStyle}
                      classNamePrefix="react-select"
                      className="react-select-container"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row xs={1} md={1} lg={2}>
                <Col>
                  <FormGroup error={getErrorMessageByFieldName('brand')}>
                    <label htmlFor="marca">Marca *</label>
                    <Input
                      placeholder="Marca *"
                      value={brand}
                      onChange={handleBrandChange}
                      maxLength={20}
                      disabled={edit}
                      error={getErrorMessageByFieldName('brand')}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup error={getErrorMessageByFieldName('capacity')}>
                    <label htmlFor="capacity">Capacidade *</label>
                    <Input
                      placeholder="Capacidade *"
                      value={capacity}
                      onChange={handleCapacityChange}
                      maxLength={2}
                      disabled={edit}
                      error={getErrorMessageByFieldName('capacity')}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row xs={1} md={1} lg={2}>
                <Col>
                  <FormGroup error={getErrorMessageByFieldName('model')}>
                    <label htmlFor="ano">Ano *</label>
                    <Input
                      placeholder="Ano *"
                      value={model}
                      onChange={handleModelChange}
                      maxLength={4}
                      disabled={edit}
                      error={getErrorMessageByFieldName('model')}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup error={getErrorMessageByFieldName('consumption')}>
                    <label htmlFor="codVeiculo">Consumo *</label>
                    <Input
                      placeholder="Consumo médio (km/L) *"
                      value={consumption}
                      onChange={handleConsumptionChange}
                      maxLength={2}
                      error={getErrorMessageByFieldName('consumption')}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row xs={1} md={1} lg={2}>
                <Col>
                  <FormGroup>
                    <label htmlFor="codVeiculo">Local de trabalho</label>
                    <Select
                      value={workplace}
                      options={workplacesOptions}
                      onChange={(opt) => handleLocTrabChange(opt!)}
                      placeholder="Selecione o local de trabalho"
                      styles={CustomStyle}
                      isDisabled={isSelectLoading || !doesListWorkplacesExists}
                      isLoading={isSelectLoading}
                      classNamePrefix="react-select"
                      className="react-select-container"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <label htmlFor="codVeiculo">Linhas associadas</label>
                    <Select
                      value={affreightmentLines}
                      options={linesOptions}
                      onChange={(opt) => handleLinesChange(opt)}
                      placeholder="Selecione as linhas"
                      isMulti
                      isDisabled={isLinesSelectDisabled || !doesListWorkplacesExists}
                      isLoading={isLinesSelectLoading}
                      styles={CustomStyle}
                      components={animatedComponents}
                      closeMenuOnSelect={false}
                      classNamePrefix="react-select"
                      className="react-select-container"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <ButtonContainer>
                <Button type="button" disabled={!isFormValid} onClick={edit ? editLine : createLine}>
                  {edit ? 'Salvar alterações' : 'Criar veículo'}
                </Button>
              </ButtonContainer>

            </Container>
          </Form>
        </OpacityAnimation>
      )}

      {!apiVehicleFetched && (
        <NoData
          icon="sad"
          label={(
            <>
              Ocorreu um erro ao recuperar os dados do veículo.
              <button type="button" onClick={handleGetVehicleTryAgain}>Tentar Novamente</button>
            </>
          )}
        />
      )}

      {!apiWorkplaceFetched && (
        <NoData
          icon="sad"
          label={(
            <>
              Ocorreu um erro ao obter os locais de trabalho para carregar o formulário.
              <button type="button" onClick={handleGetWorkplacesTryAgain}>Tentar Novamente</button>
            </>
          )}
        />
      )}

      {!doesListWorkplacesExists && (
        <NoData icon="emptyBox" label="Esta empresa não possui nenhum local de trabalho para fretamento. Para cadastrar um veículo, é necessário haver pelo menos um local de trabalho." />
      )}
    </>
  );
}
